import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';
import theme from '@styles/theme';

type LogTableRowType = {
    header: HeaderType[];
    data: any;
};

const LogTableRow = ({ header = [], data }: LogTableRowType) => {
    const navigate = useNavigate();
    return (
        <TableRow onClick={() => navigate(`/equipment/${data?.id}`)} $bold>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data?.createdAt).format('YY.MM.DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.title || '-'}
            </TableCell>
            <TableCell
                $minWidth={header[2].minWidth}
                $width={header[2].width}
                $fontColor={theme.colors.deepGrayFontColor}
                $alignRight
            >
                {data?.time || '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(LogTableRow);
